import { Workbook } from "exceljs";
import { EventRatingsResponse } from "../../services/reports.service";
import { applyHeaderStyle } from "./workbook-styles";

export const addEventRatingsSheets = (
	workbook: Workbook,
	data: EventRatingsResponse,
): void => {
	if (!data.chart) return;
	if (data.chart.ratingType === "SCORED_SUM" && data.chart.scoredSum) {
		addScoredSumSheets(workbook, data);
	} else if (
		data.chart.ratingType === "INDEPENDENT_RATINGS" &&
		data.chart.independent
	) {
		addIndependentSheets(workbook, data);
	}
};

const addScoredSumSheets = (
	workbook: Workbook,
	data: EventRatingsResponse,
): void => {
	const chart = data.chart;
	if (!chart?.scoredSum) return;

	const popAvg = workbook.addWorksheet("Population avg");
	popAvg.columns = [
		{ header: "Day", key: "day", width: 8 },
		{ header: "Avg score", key: "avgScore", width: 12 },
		{ header: "Submissions", key: "submissionCount", width: 14 },
	];
	applyHeaderStyle(popAvg.getRow(1));

	for (const d of chart.scoredSum.avgScoreByDay) {
		const r = popAvg.addRow(d);
		r.getCell("avgScore").numFmt = "0.0";
	}

	// AC names this sheet "Per enrollment", but Incentive disbursement already
	// uses that name. Disambiguate in the consolidated workbook.
	const perEnr = workbook.addWorksheet("Ratings per enrollment");
	perEnr.columns = [
		{ header: "Enrollment", key: "enrollmentId", width: 28 },
		{ header: "Participant", key: "participantName", width: 28 },
	];
	applyHeaderStyle(perEnr.getRow(1));
	for (const e of data.enrollments) {
		perEnr.addRow(e);
	}
};

const addIndependentSheets = (
	workbook: Workbook,
	data: EventRatingsResponse,
): void => {
	const chart = data.chart;
	if (!chart?.independent) return;
	const ind = chart.independent;

	const distress = workbook.addWorksheet("Distress rating");
	distress.columns = [
		{ header: "Day", key: "day", width: 8 },
		{ header: "Avg distress", key: "avgDistress", width: 14 },
		{ header: "Submissions", key: "submissionCount", width: 14 },
	];
	applyHeaderStyle(distress.getRow(1));
	for (const d of ind.avgDistressByDay) {
		const r = distress.addRow(d);
		r.getCell("avgDistress").numFmt = "0.0";
	}

	const emoji = workbook.addWorksheet("Emoji distribution");
	emoji.columns = [
		{ header: "Day", key: "day", width: 8 },
		...ind.emojiField.values.map((v) => ({
			header: v,
			key: `emoji_${v}`,
			width: 12,
		})),
	];
	applyHeaderStyle(emoji.getRow(1));
	for (const d of ind.emojiCountsByDay) {
		const rowData: Record<string, unknown> = { day: d.day };
		for (const v of ind.emojiField.values) {
			rowData[`emoji_${v}`] = d.counts[v] ?? 0;
		}
		emoji.addRow(rowData);
	}

	// AC names this sheet "Per enrollment", but Incentive disbursement already
	// uses that name. Disambiguate in the consolidated workbook.
	const perEnr = workbook.addWorksheet("Ratings per enrollment");
	perEnr.columns = [
		{ header: "Enrollment", key: "enrollmentId", width: 28 },
		{ header: "Participant", key: "participantName", width: 28 },
	];
	applyHeaderStyle(perEnr.getRow(1));
	for (const e of data.enrollments) {
		perEnr.addRow(e);
	}
};
